
import PropTypes from 'prop-types';
import FileViewer from 'react-file-viewer';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '80vh',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    color: '#626262',
    fontFamily: 'Inter',
    fontSize: '14px',
  }
}));

const PDFRenderer = ({ file }) => {
  const classes = useStyles();

  const onError = (e) => {
    console.error('Error loading PDF:', e);
  };

  return (
    <div className={classes.container}>
      <FileViewer
        fileType="pdf"
        filePath={file}
        onError={onError}
        errorComponent={() => (
          <div className={classes.errorContainer}>
            {/* Error loading PDF. Please try again. */}
          </div>
        )}
      />
    </div>
  );
};

PDFRenderer.propTypes = {
  file: PropTypes.string.isRequired,
};

export default PDFRenderer; 